import type { WorkspaceType } from 'state/workspaces/model';
import type { BaseWorkspaceTabContent } from 'state/workspaces/tabContent/tabContent.model';

export type OrdersBasketWorkspaceTabContent = BaseWorkspaceTabContent & {
  workspace: WorkspaceType;
  formIds: readonly string[];
  wrapperType?: string;
  productSubtype?: string;
  productType?: string;
};

export type OrdersBasketWorkspaceTabContentState = Record<string, Readonly<OrdersBasketWorkspaceTabContent>>;

export const initialOrdersBasketWorkspaceTabContentState: OrdersBasketWorkspaceTabContentState = {};
